import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import './styles.scss';
import './change-password-modal/styles.scss';
import {compose} from 'redux';
import * as fonts from '../../util/fonts';
import AppWrapper from '../../components/app-wrapper';
import Icon from '../../components/icon';
import {Column, Row} from '../../components/layout';
import {strings} from '../../util/strings';
import {
  addToGlobalStyles,
  addToUser,
  addToWizard,
  setUser,
} from '../../store/actions';
import AppTextInput from '../../components/input/app-text-input';
import colors from '../../util/colors';
import {Icons} from '../../util/icons';
import ChangePasswordModal from './change-password-modal';
import ModalTemplate from '../../components/modal';
import {putUserPersonalDate, uriUpdateUserdata} from './../../api/endpoints';
import {patch, put} from '../../api/api';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../components/forms';
import {decodeToken, numberWithSpaces} from '../../util/utility';
import AppErrorMessage from '../../components/app-error-message';
import {AuthConsumer} from '../../providers/AuthProvider';
import ConfirmPasswordModal from '../../components/headers/app-header/virtual-card/customer-not-found/confirm-password-modal/ConfirmPasswordModal';

interface ProfileProps {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.myProfile;
  messageLabels: typeof strings.pt.messages;
  setUser(value: any): void;
  addToWizard(value: any): void;
  buStyles: any;
  addToUser(value: any): void;
  accessToken: any;
  language: any;
}

function Profile({
  user,
  labels,
  messageLabels,
  setUser,
  buStyles,
  addToUser,
  selectedBu,
  accessToken,
  language,
}: ProfileProps) {
  const [initialValues, setInitialValues] = useState({
    name: user.given_name + ' ' + user.family_name,
    email: user.email,
    phone:
      user.phone_number && user.phone_number !== '0' ? user.phone_number : '',
  });
  const [values, setValues] = useState(initialValues);
  const [valid, setValid] = useState(false);
  const [changed, setChanged] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSaveResultModal, setShowSaveResultModal] = useState(false);
  const [saveOperationResult, SetSaveOperationResult] = useState(false);
  const [saveResultMessage, setSaveResultMessage] = useState(
    'Dados do perfil alterados'
  ); // todo label
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<any>();
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    name: false,
    email: false,
    phone: false,
  });
  const [disableNameField, setDisableNameField] = useState(true);
  const [disableEmailField, setDisableEmailField] = useState(true);
  const [disablePhoneField, setDisablePhoneField] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const featureName = 'Profile';

  useEffect(() => {
    setChanged(compareValues());
  }, [values]);

  const compareValues = (): boolean =>
    initialValues.name !== values.name ||
    initialValues.email !== values.email ||
    initialValues.phone !== values.phone;

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp('^(?![\\s\\S]{51,})([^0-9\\s]+\\s[^0-9\\s]{1,30})$'),
        labels?.myProfile_nameValidationError
      ),
    email: Yup.string()
      .required(messageLabels?.requiredField)
      .email(messageLabels.invalidEmailFormat)
      .label('E-mail'),
    phone: Yup.string()
      .required(messageLabels?.requiredField)
      .max(13)
      .matches(new RegExp('^[0-9+]{9,}$'), messageLabels?.invalidFormat),
  });

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: true});
      };
      icon.onmouseout = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: false});
      };
    }
  };

  const handleFocus = (elID: any) => {
    document.getElementById(elID)?.focus();
    switch (elID) {
      case 'email':
        setDisableEmailField(false);
        break;
      case 'name':
        setDisableNameField(false);
        break;
      case 'phone':
        setDisablePhoneField(false);
        break;
      default:
        return;
    }
  };

  return (
    <AuthConsumer>
      {({signinSilent}) => (
        <>
          <AppForm
            ignoreInitialValidation={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onValidation={(valid) => {
              setValid(valid);
            }}
            onSubmit={async (values) => {
              setSubmitting(true);
              setDisableNameField(true);
              setDisableEmailField(true);
              setDisablePhoneField(true);
              let body: any;
              if (values.phone || values.phone !== '') {
                body = {
                  userName: user.sub,
                  fullName: values.name,
                  nif: user.nif,
                  phoneNumber: values.phone,
                  email: values.email,
                  language: user?.language || language,
                };
              } else {
                body = {
                  userName: user.sub,
                  fullName: values.name,
                  nif: user.nif,
                  email: values.email,
                  language: user?.language || language,
                };
              }

              try {
                const response = await patch(
                  uriUpdateUserdata(),
                  body,
                  featureName
                );
                if (response !== false) {
                  try {
                    const bodyPersonalDate = {
                      username: user.sub,
                    };
                    await put(putUserPersonalDate(), bodyPersonalDate);
                  } catch {}
                  setSaveResultMessage(labels?.myProfile_saveSucceeded);
                  SetSaveOperationResult(true);
                  setShowSaveResultModal(true);
                  setInitialValues({
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                  });
                  setChanged(false);
                  const decodedInfo = decodeToken(accessToken);

                  const userInfo = {...decodedInfo};
                  setUser(userInfo);
                  setUser({
                    ...user,
                    given_name: values.name?.split(' ')[0],
                    family_name: values.name.substring(
                      values.name.indexOf(' ') + 1
                    ),
                    phone_number: values.phone,
                    email: values.email,
                  });

                  const isNotFound: any = user.state === 'NOT_FOUND';

                  if (selectedBu.buId !== 'NOTCLIENT') {
                    addToUser({
                      state: 'CLIENT',
                    });
                  } else {
                    if (isNotFound) {
                      addToUser({
                        state: 'NOT_FOUND',
                      });
                    } else {
                      addToUser({
                        state: 'NOT_CLIENT',
                      });
                    }
                  }

                  setInitialValues({
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                  });
                  signinSilent();
                } else if (response === false) {
                  setSaveResultMessage(labels?.myProfile_saveFailed);
                  SetSaveOperationResult(false);
                  setShowSaveResultModal(true);
                }
              } catch (err: any) {
                console.log('errpr', err);
                setSaveResultMessage(labels?.myProfile_saveFailed);
                SetSaveOperationResult(false);
                setShowSaveResultModal(true);
              } finally {
                setSubmitting(false);
              }
            }}>
            <Row className="justify-content-center bg-white profile-container">
              <Column>
                <Row className="profile-firstrow">
                  <Column className="profile-title-column">
                    <Row className="profile-title-row">
                      <p
                        className="mb-0"
                        style={{
                          ...fonts.XL,
                          ...fonts.Bold,
                          color: colors.black,
                        }}>
                        {labels?.myProfile_pageTitle}
                      </p>
                    </Row>
                    <Row className="profile-title-row p-0 m-0">
                      <p
                        className="profile-subtitle"
                        style={{
                          ...fonts.M,
                          color: colors.black,
                        }}>
                        {labels?.myProfile_dataOfRegister}
                      </p>
                    </Row>
                  </Column>
                  <Column className="profile-space-between-firstrow"></Column>
                  <Column className="profile-change-passowrd-column">
                    <Row className="pt-3 pb-0 mb-0">
                      <p
                        className="mb-2 pl-3"
                        style={{
                          ...fonts.SM,
                          ...fonts.Light,
                          color: colors.black,
                        }}>
                        {labels?.myProfile_emailLabel}
                      </p>
                    </Row>
                    <Row className="pt-0 mt-0 pb-0 mb-0">
                      <AppTextInput
                        disabled
                        onChange={() => {}}
                        placeholder={user.sub}></AppTextInput>
                    </Row>
                    <Row
                      className="new-register-text-row"
                      style={{...fonts.SM}}>
                      <div className="new-register-text">
                        {labels?.myProfile_updateEmail}
                        <a
                          style={{color: buStyles.primaryColor}}
                          onClick={() => setShowConfirmPassword(true)}>
                          {labels?.myProfile_newRegister}
                        </a>
                      </div>
                    </Row>
                    <Row className="justify-content-center m-0">
                      <a
                        className="profile-change-password-anchor"
                        style={{
                          ...fonts.M,
                          ...fonts.Bold,
                          color: buStyles?.primaryColor || colors.blue,
                        }}
                        onClick={() => setShowModal(true)}>
                        {labels?.myProfile_changePassword}
                      </a>
                      <Icon
                        name={Icons.CHEVRON_RIGHT}
                        className="my-profile-icon-right"
                        changeViewbox
                        color={buStyles?.primaryColor || colors.blue}
                      />
                    </Row>
                  </Column>
                </Row>

                <Column className="profile-information-container">
                  <Row className="profile-row-edit-data">
                    <Column className="profile-column-edit-data">
                      <Row className="m-0">
                        {' '}
                        <p
                          className="mb-1 pl-3"
                          style={{
                            ...fonts.SM,
                            color: colors.black,
                          }}>
                          {labels?.myProfile_nameLabel}
                        </p>
                      </Row>
                      <Row
                        className="profile-input-row m-0"
                        onClick={() => setDisableNameField(false)}>
                        <AppFormField
                          id="name"
                          className="profile-input"
                          name="name"
                          disabled={disableNameField}
                          handleFormikContext={(formik) => {
                            if (values !== (formik as any).values) {
                              setValues(formik.values);
                            }
                            if (errors !== (formik as any).errors) {
                              setErrors(formik.errors);
                            }
                          }}
                          onMouseOver={(e) => {
                            defineOnMouseFunctions(e, 'name');
                          }}></AppFormField>
                        <Icon
                          className="profile-input-icon field-adornment"
                          onClick={() => handleFocus('name')}
                          name={Icons.PENCIL}
                          width="20"
                          height="20"
                          changeViewbox
                          viewBox={'0 0 24 24'}
                          color={buStyles?.primaryColor || colors.blue}
                        />
                        {hoverErrorIcons.name && (
                          <AppErrorMessage
                            message={errors && errors.name}
                            className={
                              errors &&
                              errors.name ===
                                labels?.myProfile_nameValidationError
                                ? 'profile-pop-up-error-messages-name-match'
                                : 'profile-pop-up-error-messages'
                            }
                          />
                        )}
                      </Row>
                    </Column>
                    <Column className="profile-column-edit-data">
                      <Row className="m-0">
                        {' '}
                        <p
                          className="mb-1 pl-3"
                          style={{
                            ...fonts.SM,
                            color: colors.black,
                          }}>
                          {labels?.myProfile_contactLabel}
                        </p>
                      </Row>
                      <Row
                        className="profile-input-row m-0"
                        onClick={() => setDisableEmailField(false)}>
                        <AppFormField
                          id="email"
                          className="profile-input"
                          name="email"
                          disabled={disableEmailField}
                          type="email"
                          onMouseOver={(e) => {
                            defineOnMouseFunctions(e, 'email');
                          }}></AppFormField>
                        <Icon
                          className="profile-input-icon field-adornment"
                          name={Icons.PENCIL}
                          onClick={() => handleFocus('email')}
                          width="20"
                          height="20"
                          changeViewbox
                          viewBox={'0 0 24 24'}
                          color={buStyles?.primaryColor || colors.blue}
                        />
                        {hoverErrorIcons.email && (
                          <AppErrorMessage
                            message={errors && errors.email}
                            className="profile-pop-up-error-messages"
                          />
                        )}
                      </Row>
                    </Column>

                    <Column className="profile-column-edit-data">
                      <Row className="m-0">
                        {' '}
                        <p
                          className="mb-1 pl-3"
                          style={{
                            ...fonts.SM,
                            color: colors.black,
                          }}>
                          {labels?.myProfile_phoneNumberLabel}
                        </p>
                      </Row>
                      <Row
                        className="profile-input-row m-0"
                        onClick={() => setDisablePhoneField(false)}>
                        <AppFormField
                          id="phone"
                          className="profile-input"
                          name="phone"
                          disabled={disablePhoneField}
                          maxLength={13}
                          modifyDisplayValue={(value) =>
                            numberWithSpaces(value)
                          }
                          onMouseOver={(e) => {
                            defineOnMouseFunctions(e, 'phone');
                          }}></AppFormField>
                        <Icon
                          className="profile-input-icon field-adornment"
                          name={Icons.PENCIL}
                          onClick={() => handleFocus('phone')}
                          width="20"
                          height="20"
                          changeViewbox
                          viewBox={'0 0 24 24'}
                          color={buStyles?.primaryColor || colors.blue}
                        />
                        {hoverErrorIcons.phone && (
                          <AppErrorMessage
                            message={errors && errors.phone}
                            className="profile-pop-up-error-messages"
                          />
                        )}
                      </Row>
                    </Column>
                  </Row>
                  <Row className="justify-content-center">
                    <AppFormSubmitButton
                      disabled={!valid || !changed || submitting}
                      className="profile-save-button"
                      title={labels?.myProfile_button}></AppFormSubmitButton>
                  </Row>
                </Column>
              </Column>
            </Row>
            <ConfirmPasswordModal
              show={showConfirmPassword}
              setShow={setShowConfirmPassword}
            />
            <ChangePasswordModal
              showModal={showModal}
              setShowModal={setShowModal}
            />
            <ModalTemplate
              inputType="confirm"
              show={showSaveResultModal}
              hideFooter={true}
              onHide={() => {
                setShowSaveResultModal(false);
              }}>
              {saveOperationResult && (
                <div className="modal-error-container">
                  <Row className="modal-success-title-row">
                    {labels?.myProfile_pageTitle}
                  </Row>
                  <Row className="my-profile-submit-button-row">
                    <Icon
                      name={Icons.SUCCESS}
                      width={'40'}
                      height={'40'}
                      color={colors.black}
                      changeViewbox
                    />
                  </Row>
                  <Row className="my-profile-modal-success">
                    {labels?.myProfile_saveSucceeded}
                  </Row>
                  <Row className="my-profile-submit-button-row">
                    <AppFormSubmitButton
                      title="Ok"
                      className="stepper-continue-button"
                      variant="secondary"
                      onClick={() => {
                        setShowSaveResultModal(false);
                      }}
                    />
                  </Row>
                </div>
              )}
              {!saveOperationResult && (
                <div className="modal-error-container">
                  <Row className="my-profile-submit-button-row">
                    <Icon
                      name={Icons.ALERT_PROBLEM}
                      width={'40'}
                      height={'40'}
                      color={colors.alertRed}
                      changeViewbox
                    />
                  </Row>
                  <Row
                    style={{...fonts.Bold, ...fonts.M, color: colors.alertRed}}>
                    {labels?.myProfile_saveFailed}
                  </Row>
                  <Row className="my-profile-submit-button-row">
                    <AppFormSubmitButton
                      title="Ok"
                      className="stepper-continue-button"
                      variant="secondary"
                      onClick={() => {
                        setShowSaveResultModal(false);
                      }}
                    />
                  </Row>
                </div>
              )}
            </ModalTemplate>
          </AppForm>
        </>
      )}
    </AuthConsumer>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  globalStyles,
  accessToken,
  language,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.myProfile,
  messageLabels: strings.value.pt.messages,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  accessToken: accessToken.value,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setUser: (value: any) => dispatch(setUser(value)),
  addToUser: (value: any) => dispatch(addToUser(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(Profile));
